import { useEffect, useState } from 'react'
import { PreparePurchaseLessonPack } from './query'
import { useMutation } from '@apollo/client'

export const useGetClientSecret = lessonPackId => {
  const [clientSecret, setClientSecret] = useState(null)
  const [preparePurchaseLessonPack, { data, loading, error }] = useMutation(
    PreparePurchaseLessonPack,
  )

  useEffect(() => {
    // Reset clientSecret when lesson pack changes to ensure clean state
    setClientSecret(null)
    if (lessonPackId) {
      preparePurchaseLessonPack({
        variables: {
          lessonPackId,
        },
      })
    }
  }, [lessonPackId, preparePurchaseLessonPack])

  useEffect(() => {
    if (data?.preparePurchaseLessonPack?.success) {
      setClientSecret(
        data?.preparePurchaseLessonPack?.paymentIntent?.clientSecret,
      )
    }
  }, [data])

  return { clientSecret, loading, error }
}
